import React, { useState, useEffect } from 'react';
import { Container, Grid, FormControlLabel, Button } from '@material-ui/core';
import { CustomeAlert } from 'Components/Alert/Alert';
import {
    LOGOUT,
    USER_SELECT_LIST,
    USER_ACTIVATE,
    USER_DELETE
} from 'ConstComponents';
import Switch from '@material-ui/core/Switch';

import DeleteIcon from '@material-ui/icons/Delete';
import Backdrop from '@material-ui/core/Backdrop';
import Loader from 'Components/Loader/Loader';

import ReactTable from 'Components/ReactTable/ReactTable';

import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { ConfirmAlert } from 'Components/Alert/ConfirmAlert';

export const User = () => {
    const classes = commonStyle();
    const [users, setUsers] = useState([]);
    const [mainColumns, setMainColumns] = useState([]);

    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [confirmAlertRequest, setConfirmAlertRequest] = useState({});

    const onClick = item => {
        var RequestObj = { UserID: item };

        setIsAlertOpen(true);
        setConfirmAlertRequest(RequestObj);
    };

    const activate = async (item, value) => {
        var jsonObj = {
            UserID: item,
            IsActive: value
        };
        var request = JSON.stringify(jsonObj);
        setIsError(false);
        setLoadingOpen(true);

        const response = await USER_ACTIVATE(request);
        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();

        setSeverity('success');
        setResponseMessage(response.data);

        if (!response.status) setSeverity('error');

        setIsError(true);
        selectUser();
    };

    const selectUser = async () => {
        setLoadingOpen(true);
        const response = await USER_SELECT_LIST();
        setLoadingOpen(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setIsError(true);
            setResponseMessage(response.data);
            setSeverity('error');
            return;
        }

        var data = JSON.parse(response.data);
        setUsers(data);
    };

    useEffect(() => {
        selectUser();
        createColumns();
    }, []);

    const Delete = async request => {
        setIsError(false);
        setLoadingOpen(true);
        var jsonReq = JSON.stringify(request);
        const response = await USER_DELETE(jsonReq);
        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();
        setSeverity('success');
        setResponseMessage(response.data);

        if (!response.status) {
            setSeverity('error');
            return setIsError(true);
        }

        selectUser();
    };

    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'UserID',
            srno: true
        });

        columns.push({
            label: 'UserName',
            name: 'UserName'
        });
        columns.push({
            label: 'MobileNo',
            name: 'MobileNo'
        });

        columns.push({
            label: 'Active',
            name: 'IsActive',
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    const userID = tableMeta.rowData[0];
                    return (
                        <FormControlLabel
                            value={value ? 'Yes' : 'No'}
                            control={
                                <Switch
                                    color="primary"
                                    checked={value}
                                    value={value ? 'Yes' : 'No'}
                                />
                            }
                            onChange={event => {
                                var newValue =
                                    event.target.value === 'Yes' ? false : true;
                                updateValue(newValue);
                                activate(userID, newValue);
                            }}
                        />
                    );
                }
            }
        });

        columns.push({
            label: 'Delete ',
            name: 'UserID',
            options: {
                filter: false,
                sort: false,
                customBodyRender: value => {
                    return (
                        <DeleteIcon
                            color="secondary"
                            variant="contained"
                            onClick={event => {
                                onClick(value);
                            }}
                        />
                    );
                }
            }
        });

        setMainColumns(columns);
    };

    return (
        <>
            {isError ? (
                <CustomeAlert
                    isOpen={isError}
                    message={responseMessage}
                    severity={severity}
                    onCloseCallback={alertState => {
                        setIsError(alertState);
                    }}
                />
            ) : null}
            {isAlertOpen ? (
                <ConfirmAlert
                    isOpen={isAlertOpen}
                    title="Delete Confirmation"
                    message="Are you sure to delete this user."
                    request={confirmAlertRequest}
                    positiveButtonClick={request => {
                        setIsAlertOpen(false);
                        Delete(request);
                    }}
                    negativeButtonClick={() => {
                        setIsAlertOpen(false);
                    }}
                />
            ) : null}

            <Backdrop className={classes.backdrop} open={loadingOpen}>
                <Loader />
            </Backdrop>
            <h2 className={classes.PaperHead_h2}>Active Agent</h2>

            <ReactTable List={users} columns={mainColumns} />
        </>
    );
};
